import { Image } from "@/app/components/image"
import { getCollectionHref } from "@/app/navigation/collection"
import { getItemHref } from "@/app/navigation/item"
import type { BidItem } from "@anaconda/core/bid/types"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import Link from "next/link"

interface Props {
  bid: BidItem
}
export function BidEntity({ bid }: Props) {
  if (bid.entity.type === "item") {
    return (
      <Miniature
        image={bid.entity.nft.image}
        alt={`${bid.entity.nft.name} nft`}
        text={bid.entity.nft.name}
        href={getItemHref(bid.entity.nft.id)}
      />
    )
  }

  return (
    <Miniature
      image={bid.entity.collection.image}
      alt={`${bid.entity.collection.name} collection`}
      text={bid.entity.collection.name}
      href={getCollectionHref(bid.entity.collection.id)}
    />
  )
}

export function MiniatureSkeleton() {
  return (
    <div className="flex w-full items-center gap-3">
      <Skeleton className="h-8 w-8" />
      <Skeleton className="h-6 w-[80px]" />
    </div>
  )
}

function Miniature({
  image,
  alt,
  text,
  href,
}: { image?: string; alt: string; text: string; href: string }) {
  return (
    <Link
      href={href}
      className="flex w-full items-center gap-3"
      prefetch={false}
    >
      <div className="relative aspect-square w-8 flex-shrink-0 overflow-hidden rounded-sm">
        <Image imageSrc={image} alt={alt} className="object-contain" />
      </div>
      <span className="truncate">{text}</span>
    </Link>
  )
}
